import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Leaf, Droplet, FileText } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const FEATURES = [
  [Leaf, "Professionelle Fußpflege"],
  [Droplet, "Spezialisiert auf diabetische Füße"],
  [FileText, "Rechnungen werden ausgestellt"],
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="ueber-mich" ref={ref} data-testid="about-section" className="bg-blush/60 py-24 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-24">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative mx-auto aspect-[4/5] w-full max-w-md overflow-hidden rounded-b-full bg-champagne">
            <motion.img style={{ y, scale: 1.18 }} src="/img/hero.jpg" alt="Handtuch, Kerze und rosé Tulpen in heller Spa-Atmosphäre" loading="lazy" className="h-full w-full object-cover" />
          </div>
          <p className="absolute -bottom-6 left-1/2 w-max -translate-x-1/2 font-script text-4xl text-gold-deep sm:text-5xl">Weil jeder Schritt zählt.</p>
        </Reveal>
        <div className="order-1 lg:order-2">
          <Reveal>
            <Eyebrow index="02">Über mich</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-5xl">
              Deine Füße <span className="italic text-gold-deep">in besten Händen.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 font-serif text-2xl leading-snug text-ink sm:text-[1.7rem]">
              „Als erfahrene Fachfußpflegerin mit einer Zusatzqualifizierung für diabetische Füße biete ich dir eine Fußpflege an, die deine Fußgesundheit fördert und dein Wohlbefinden steigert.“
            </p>
            <p className="mt-5 font-script text-4xl text-gold-deep" data-testid="about-signature">Aliona Birsan</p>
          </Reveal>
          <div className="mt-10 grid gap-4 sm:grid-cols-3">
            {FEATURES.map(([Icon, label], i) => (
              <Reveal key={label} delay={0.15 + i * 0.08} className="flex items-center gap-3 border-t border-gold/30 pt-4 sm:flex-col sm:items-start">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-gold/40 bg-paper">
                  <Icon className="h-[18px] w-[18px] text-gold-deep" strokeWidth={1.4} />
                </span>
                <span className="text-sm leading-snug text-ink-soft">{label}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
